import React, { Fragment, useEffect } from "react";
import { isAndroid } from "../feature/core";
import Img from "./basic/Img";
import ModalScroll from "./ModalScroll";

function ModalPrograms({ programData }) {
    // calcScrollBarHeight();
    let modalMain = document.getElementById("modal-main");
    let modalContents = document.getElementById("modal-contents");
    let modal = document.getElementById("modal-contents-main");
    let contents = document.getElementById("modal-contents-left");
    let toggle = document.getElementById("scrollvar-position");
    let bar = document.getElementById("scrollvar-bg");

    const closeModal = () => {
        let modal = document.getElementById("modal-wrap");
        modal.style.setProperty("display", "none");
        document.body.style.overflowY = "scroll";
    };
    const calcScrollBarHeight = () => {
        modal = document.getElementById("modal-contents-main");
        contents = document.getElementById("modal-contents-left");
        toggle = document.getElementById("scrollvar-position");
        bar = document.getElementById("scrollvar-bg");
        let toggleHeight =
            (modal.scrollHeight * bar.scrollHeight) / contents.scrollHeight;
        toggle.style.setProperty("height", toggleHeight + "px");
    };
    const scrollFunc = () => {
        calcScrollBarHeight();
        let scrollHeightCalc =
            (toggle.scrollHeight * contents.scrollTop) / modal.scrollHeight;
        toggle.style.setProperty(
            "transform",
            "translateY(" + scrollHeightCalc + "px)"
        );
    };
    window.addEventListener("load", () => {
        let modalMain = document.getElementById("modal-main");
        let modalContents = document.getElementById("modal-contents");
        if (isAndroid) {
            modalMain.style.setProperty("height", window.innerHeight + "px");
            modalContents.style.setProperty(
                "height",
                window.innerHeight + "px"
            );
        }
    });
    window.addEventListener("resize", () => {
        let modalMain = document.getElementById("modal-main");
        let modalContents = document.getElementById("modal-contents");
        if (isAndroid) {
            modalMain.style.setProperty("height", window.innerHeight + "px");
            modalContents.style.setProperty(
                "height",
                window.innerHeight + "px"
            );
        }
    });

    const ifPerformerContain = (isContain) => {
        if (isContain) {
            return (
                <div className="modal-performer-text performer2">
                    <p className="modal-performer-name">
                        {isContain.name}
                        <span>{isContain.job}</span>
                    </p>
                    <p className="modal-performer-detail">
                        {isContain.info?.match(/\n/) ? <br /> : isContain.info}
                    </p>
                </div>
            );
        } else {
            return;
        }
    };

    const AdditionalContents = ({ baseClass, contents }) => {
        return (
            <div
                className={`${baseClass}_additional`}
                style={{ height: `${window.innerHeight}px` }}
            >
                <div className={`${baseClass}_additional-content`}>
                    {contents.map((c, idx) => (
                        <div
                            className={`${baseClass}_additional-content-item`}
                            key={idx}
                        >
                            <a
                                href={c}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${baseClass}_additional-content-item_link`}
                            >
                                <Img fileName="modal_relative_text" />
                            </a>
                            <Img
                                fileName="cursor"
                                className={`${baseClass}_additional-content-item_cursor`}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    useEffect(() => {
        calcScrollBarHeight();
    }, [programData]);

    const isTextWhite = (genre) => {
        return genre.includes("entame");
    };

    return (
        <div
            className={`modal-contents ${
                isTextWhite(programData.category) ? "text-white" : "text-black"
            }`}
            id="modal-contents"
        >
            <div className="modal-title">
                <div className="modal-title_border-left-wrap">
                    <div className="modal-title_border"></div>
                    <div className="modal-title_border"></div>
                    <div className="modal-title_border"></div>
                </div>
                <Img fileName="modalTitle" />
                <div className="modal-title_border-right-wrap">
                    <div className="modal-title_border"></div>
                    <div className="modal-title_border"></div>
                    <div className="modal-title_border"></div>
                </div>
                <div onClick={() => closeModal()} className="modal-title-close">
                    <Img fileName="modalCloseButton" />
                </div>
            </div>
            <div id="modal-contents-main" className="modal-contents-main">
                <div
                    id="modal-contents-left"
                    className="modal-contents-left"
                    onScroll={scrollFunc}
                >
                    <iframe
                        width="560"
                        height="315"
                        id="ytb-iframe"
                        id="modal-thumbnail"
                        className="modal-thumbnail"
                        src={
                            "https://youtube.com/embed/" + programData.movieLink
                        }
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                    <div
                        id="modal-program-name_sche"
                        className={
                            "modal-program-name_sche bgcolor_" +
                            programData.category
                        }
                    >
                        <Img fileName={programData.thumbnailLink + "_title"} />
                    </div>

                    <div className="modal-share-wrap">
                        <div className="modal-share-icon">
                            <Img fileName={programData.channelIcon} />
                        </div>
                        <div className="modal-share-comment">
                            <svg
                                className="comment_svg"
                                id=""
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 190.66 104.33"
                            >
                                <g id="_ポップアップページ">
                                    <g>
                                        <path
                                            className={
                                                "bgcolor_" +
                                                programData.category
                                            }
                                            d="M19.27,104.04C8.8,104.04,.29,95.53,.29,85.07V19.27C.29,8.8,8.8,.29,19.27,.29H153.83c10.46,0,18.98,8.51,18.98,18.98v22.93l17.27,9.97-17.27,9.97v22.93c0,10.46-8.51,18.98-18.98,18.98H19.27Z"
                                        />
                                        <path d="M153.83,.58c10.32,0,18.69,8.37,18.69,18.69v23.1l16.98,9.8-16.98,9.8v23.1c0,10.32-8.37,18.69-18.69,18.69H19.27c-10.32,0-18.69-8.37-18.69-18.69V19.27C.58,8.95,8.95,.58,19.27,.58H153.83m0-.58H19.27C8.64,0,0,8.64,0,19.27V85.07c0,10.62,8.64,19.27,19.27,19.27H153.83c10.62,0,19.27-8.64,19.27-19.27v-22.76l16.69-9.64,.87-.5-.87-.5-16.69-9.64V19.27c0-10.62-8.64-19.27-19.27-19.27h0Z" />
                                    </g>
                                </g>
                            </svg>
                            <p className="comment-kotira color-text">
                                <a
                                    href={
                                        "https://www.youtube.com/watch?v=" +
                                        programData.movieLink
                                    }
                                    target="_blank"
                                    onClick={() => {
                                        gtag("event", "click", {
                                            event_category: "modal",
                                            event_label: `modal_comment${programData.idx}`,
                                        });
                                    }}
                                >
                                    コメントは
                                    <br />
                                    こちらから!
                                </a>
                            </p>
                            <p className="comment-gaibulink channel-annotation">
                                ※外部リンクに移動します
                            </p>
                        </div>
                    </div>

                    <div
                        id="modal-performer-wrap"
                        className="modal-performer-wrap"
                    >
                        <div className="modal-performer-title">
                            <p>出演者</p>
                        </div>
                        {ifPerformerContain(programData.performer1)}
                        {ifPerformerContain(programData.performer2)}
                        {ifPerformerContain(programData.performer3)}
                        {ifPerformerContain(programData.performer4)}
                        {ifPerformerContain(programData.performer5)}
                        {ifPerformerContain(programData.performer6)}
                    </div>
                    <div
                        id="modal-performer-wrap"
                        className="modal-performer-wrap"
                    >
                        <div className="modal-performer-title">
                            <p>コンテンツ内容</p>
                        </div>
                        <div className="modal-performer-text">
                            <p className="modal-performer-detail">
                                {programData.abstract
                                    .split(/(\n)/)
                                    .map((text) => {
                                        return text?.match(/\n/) ? (
                                            <br />
                                        ) : (
                                            text
                                        );
                                    })}
                            </p>
                        </div>
                    </div>
                </div>
                {/* <ModalScroll openExe={calcScrollBarHeight} /> */}
                <div className="modal-contents-right">
                    <div className="scrollvar-up">
                        <Img fileName="modalScrollButton" />
                    </div>
                    <div id="scrollvar-bg" className="scrollvar-bg">
                        <div
                            id="scrollvar-position"
                            className="scrollvar-position"
                        ></div>
                    </div>
                    <div className="scrollvar-down">
                        <Img fileName="modalScrollButton" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalPrograms;
